import type { HeaderFiltersProps } from '@presentation/components';
import { Container } from '@presentation/components';
import type { FC } from 'react';
import * as Styled from './styled';

export * from './types';

export const HeaderFilters: FC<HeaderFiltersProps> = (props) => {
  const { title, subtitle, decorationImage, backgroundImage, children, ...rest } = props;

  return (
    <Styled.Banner {...rest} src={backgroundImage}>
      <Container>
        {!!decorationImage && <Styled.DecorationImage src={decorationImage} />}
        {!!title && <Styled.Title>{title}</Styled.Title>}
        {!!subtitle && <Styled.Subtitle>{subtitle}</Styled.Subtitle>}
        {children}
      </Container>
    </Styled.Banner>
  );
};
